/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentClassRoomRequest } from './AppointmentClassRoomRequest';
import {
    AppointmentClassRoomRequestFromJSON,
    AppointmentClassRoomRequestFromJSONTyped,
    AppointmentClassRoomRequestToJSON,
    AppointmentClassRoomRequestToJSONTyped,
} from './AppointmentClassRoomRequest';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateAppointmentRequest
 */
export interface UpdateAppointmentRequest {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof UpdateAppointmentRequest
     */
    appointmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    onlineMeetingUrl: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateAppointmentRequest
     */
    appointmentTypeId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    duration: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAppointmentRequest
     */
    payRate: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAppointmentRequest
     */
    price: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateAppointmentRequest
     */
    maxNumberOfStudents: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    allowOnlineBooking: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    allowCancellation: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    bookingNotice: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppointmentRequest
     */
    cancellationNotice: string | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateAppointmentRequest
     */
    startDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateAppointmentRequest
     */
    endDate: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateAppointmentRequest
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    requirePayment: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateAppointmentRequest
     */
    slotIntervalMinutes: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {PriceType}
     * @memberof UpdateAppointmentRequest
     */
    priceType: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    isApprovalRequired: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAppointmentRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<AppointmentClassRoomRequest>}
     * @memberof UpdateAppointmentRequest
     */
    classRooms: Array<AppointmentClassRoomRequest>;
}



/**
 * Check if a given object implements the UpdateAppointmentRequest interface.
 */
export function instanceOfUpdateAppointmentRequest(value: object): value is UpdateAppointmentRequest {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('onlineMeetingUrl' in value) || value['onlineMeetingUrl'] === undefined) return false;
    if (!('appointmentTypeId' in value) || value['appointmentTypeId'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('maxNumberOfStudents' in value) || value['maxNumberOfStudents'] === undefined) return false;
    if (!('allowOnlineBooking' in value) || value['allowOnlineBooking'] === undefined) return false;
    if (!('allowCancellation' in value) || value['allowCancellation'] === undefined) return false;
    if (!('bookingNotice' in value) || value['bookingNotice'] === undefined) return false;
    if (!('cancellationNotice' in value) || value['cancellationNotice'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('requirePayment' in value) || value['requirePayment'] === undefined) return false;
    if (!('slotIntervalMinutes' in value) || value['slotIntervalMinutes'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    if (!('isApprovalRequired' in value) || value['isApprovalRequired'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('classRooms' in value) || value['classRooms'] === undefined) return false;
    return true;
}

export function UpdateAppointmentRequestFromJSON(json: any): UpdateAppointmentRequest {
    return UpdateAppointmentRequestFromJSONTyped(json, false);
}

export function UpdateAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['appointmentId']),
        'name': json['name'],
        'description': json['description'],
        'onlineMeetingUrl': json['onlineMeetingUrl'],
        'appointmentTypeId': ActorActivityRecordActorUserIdFromJSON(json['appointmentTypeId']),
        'duration': json['duration'],
        'payRate': json['payRate'],
        'price': json['price'],
        'maxNumberOfStudents': ApiUserTasksGetPageParameterFromJSON(json['maxNumberOfStudents']),
        'allowOnlineBooking': json['allowOnlineBooking'],
        'allowCancellation': json['allowCancellation'],
        'bookingNotice': json['bookingNotice'],
        'cancellationNotice': json['cancellationNotice'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'requirePayment': json['requirePayment'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterFromJSON(json['slotIntervalMinutes']),
        'priceType': PriceTypeFromJSON(json['priceType']),
        'isApprovalRequired': json['isApprovalRequired'],
        'isActive': json['isActive'],
        'classRooms': ((json['classRooms'] as Array<any>).map(AppointmentClassRoomRequestFromJSON)),
    };
}

export function UpdateAppointmentRequestToJSON(json: any): UpdateAppointmentRequest {
    return UpdateAppointmentRequestToJSONTyped(json, false);
}

export function UpdateAppointmentRequestToJSONTyped(value?: UpdateAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['appointmentId']),
        'name': value['name'],
        'description': value['description'],
        'onlineMeetingUrl': value['onlineMeetingUrl'],
        'appointmentTypeId': ActorActivityRecordActorUserIdToJSON(value['appointmentTypeId']),
        'duration': value['duration'],
        'payRate': value['payRate'],
        'price': value['price'],
        'maxNumberOfStudents': ApiUserTasksGetPageParameterToJSON(value['maxNumberOfStudents']),
        'allowOnlineBooking': value['allowOnlineBooking'],
        'allowCancellation': value['allowCancellation'],
        'bookingNotice': value['bookingNotice'],
        'cancellationNotice': value['cancellationNotice'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'requirePayment': value['requirePayment'],
        'slotIntervalMinutes': ApiUserTasksGetPageParameterToJSON(value['slotIntervalMinutes']),
        'priceType': PriceTypeToJSON(value['priceType']),
        'isApprovalRequired': value['isApprovalRequired'],
        'isActive': value['isActive'],
        'classRooms': ((value['classRooms'] as Array<any>).map(AppointmentClassRoomRequestToJSON)),
    };
}

